module.exports = __webpack_public_path__ + "f21c79331cd7e725f03112a9274e8a8f.pdf";